import * as React from "react";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Carousel from "react-bootstrap/Carousel";
import Modal from "react-bootstrap/Modal";

const CarouselModal = ({
  images,
  title,
  shortText,
  longText,
}: {
  images: Array<string>;
  title: string;
  shortText: React.ReactNode;
  longText: React.ReactNode;
}) => {
  const [show, setShow] = React.useState(false);
  const handleClose = React.useCallback(() => setShow(false), [setShow]);
  const handleShow = React.useCallback(() => setShow(true), [setShow]);

  const modalCarouselImages = React.useMemo(
    () =>
      images.map((image, index) => (
        <Carousel.Item key={index}>
          <img
            alt={title}
            className="d-block w-100 h-auto"
            height={100}
            src={image}
            width={100}
          />
        </Carousel.Item>
      )),
    [images, title]
  );

  return (
    <Card className="about-us-card border-0 h-100">
      <Carousel interval={null}>
        {images.map((image, i) => (
          <Carousel.Item key={i}>
            <img
              className="d-block w-100 h-auto"
              height={100}
              src={image}
              width={100}
            />
          </Carousel.Item>
        ))}
      </Carousel>
      <Card.Body className="text-dark pb-0">
        <Card.Title>{title}</Card.Title>
        <Card.Text>{shortText}</Card.Text>

        <Modal onHide={handleClose} show={show} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="d-none d-md-flex flex-row align-items-center">
            <Carousel className="w-50 me-3 pb-3">
              {modalCarouselImages}
            </Carousel>
            <div className="w-50">{longText}</div>
          </Modal.Body>
          <Modal.Body className="d-md-none">
            <Carousel className="pb-3">{modalCarouselImages}</Carousel>
            <div>{longText}</div>
          </Modal.Body>
        </Modal>
      </Card.Body>
      <Card.Footer className="bg-transparent border-0">
        <Button onClick={handleShow} variant="primary">
          Read more
        </Button>
      </Card.Footer>
    </Card>
  );
};

export default CarouselModal;
